import { gql, useMutation } from '@apollo/client';

export const DECLINE_OFFER_MUTATION = gql`
    mutation ($offerId: ID!){
        declineOffer(id: $offerId){
            bhpnDecisionDate
            comments
            declinedDate
            declinedParty
            declinedReason
            directCareHours
            firstServiceDate
            groupCareHours
            guid
            highLevelSupervisionHours
            id
            lastServiceDate
            midLevelSupervisionHours
            offerHourPercentage
            otherClinicLocation
            provideAllEstimatedHours
            provideServiceInRequiredLanguage
            provideServicesInClinic
            status
            submittedAt
        }
    }
`;

export const useDeclineOffer = () => {
    const [
        execute,
        {
            error,
            loading
        }
    ] = useMutation(DECLINE_OFFER_MUTATION);


    return {
        execute,
        error,
        loading
    };
};
